"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lazyWrappersTestIds = void 0;
const lazyWrappersTestIds = exports.lazyWrappersTestIds = {
  footer: 'footer-lazy-wrapper'
};
